import { createAsyncAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import api from '../api/apiSettings';

export const types = {
  ...addAsyncActionPostfixes({
    GET_ALL_JOB_ALERTS: 'GET_ALL_JOB_ALERTS',
    CREATE_NEW_JOB_ALERT: 'CREATE_NEW_JOB_ALERT',
    EDIT_JOB_ALERT: 'EDIT_JOB_ALERT',
    DELETE_JOB_ALERT: 'DELETE_JOB_ALERT'
  })
};

export const getAllJobAlerts = createAsyncAction(types.GET_ALL_JOB_ALERTS, () =>
  api.get(`v1/job/alert`).then((res) => res.data)
);

export const createNewJobAlert = createAsyncAction(types.CREATE_NEW_JOB_ALERT, (data) =>
  api.post(`v1/job/alert`, data).then((res) => res.data.Data)
);

export const editJobAlert = createAsyncAction(types.EDIT_JOB_ALERT, (data) =>
  api.put(`v1/job/update-alert/${data.Id}`, data).then(() => data)
);

export const deleteJobAlert = createAsyncAction(types.DELETE_JOB_ALERT, (id) =>
  api.delete(`v1/job/remove-alert?jobAlertId=${id}`).then(() => id)
);
